export function getOrdinalDay() {
  const day = getDayNoZero();
  if (day < 1 || day > 31) {
    return 'Invalid day: ' + day;
  }

  let suffix = 'th';
  if (day === '1' || day === '21' || day === '31') {
    suffix = 'st';
  } else if (day === '2' || day === '22') {
    suffix = 'nd';
  } else if (day === '3' || day === '23') {
    suffix = 'rd';
  }
  return `${this.getDayOfWeek() + ' ' + day + suffix}`;
}

export function getDay(date) {
  const d = new Date(date || Date.now());
  return d.toLocaleString('en-US', { weekday: 'short' });
}

export function getDayNumeric(date) {
  const d = new Date(date || Date.now());
  return String(d.getDate()).padStart(2, '0');
}

export function getDayNoZero(date) {
  const d = new Date(date || Date.now());
  return String(d.getDate());
}

export function getMonthShort(date) {
  const d = new Date(date || Date.now());
  return d.toLocaleString('en-US', { month: 'short' });
}

export function getYear(date) {
  const d = new Date(date);
  return d.getFullYear();
}

export function getCurrentMonth() {
  const d = new Date();
  return d.toLocaleString('en-US', { month: 'long', year: 'numeric' });
}

export function getDayOfWeek(date) {
  const d = new Date(date || Date.now());
  return d.toLocaleString('en-US', { weekday: 'long' });
}

export function getMonth(date) {
  const d = new Date(date || Date.now());
  return d.toLocaleString('en-US', { month: 'long' });
}

export function getNextMonth() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth() + 1, 1)
    .toLocaleString('en-US', { month: 'long' });
  ;
}

export function niceDate(event, separator = '●') {
  return `${getDay(
    event.metadata.date + 'T' + event.metadata.start_time
  )}
      ${getMonthShort(event.metadata.date + 'T' + event.metadata.start_time)}
      ${getDayNumeric(
    event.metadata.date + 'T' + event.metadata.start_time
  )}, ${getYear(event.metadata.date)} ${separator} ${event.metadata.start_time} Hrs`;
}

export function eventPerformed(dateString) {

  // moment.utc(state.party.metadata.date).endOf('day') <=
  // moment().startOf('day')
  const partyDate = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to 0
  partyDate.setHours(23, 59, 59, 999);
  return partyDate <= today;
}

function _getOrdinalSuffixForDate(dayNumber) {
  if (dayNumber > 3 && dayNumber < 21) return 'th';
  switch (dayNumber % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
}

/**
 * Helper function to format time in HH:MM AM/PM format.
 * Kept because no equivalent was provided in user's utilities.
 * @param {Date} date - The date object.
 * @returns {string} Formatted time string (e.g., "7:00 PM").
 */
function _formatTimeForDate(date) {
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // The hour '0' should be '12'
  const minutesStr = minutes < 10 ? '0' + minutes : minutes;
  return `${hours}:${minutesStr} ${ampm}`;
}

/**
 * Converts a date string to a pretty, human-readable format,
 * using "Today" and "Tomorrow" for respective dates.
 * Relies on globally available getDayOfWeek, getMonth, getDayNumeric.
 *
 * @param {string} startTime - The input date and time string (e.g., "2025-05-21 19:00").
 * @returns {string} The pretty formatted date string.
 */
export function attachPrettyDate(startTime) {
  if(!startTime) return '';
  // Ensure startTime is parsed correctly, 'T' helps with ISO format consistency
  const partyDate = new Date(startTime.replace(' ', 'T'));
  const now = new Date(); // Current date and time

  // Normalize 'now' and 'partyDate' to the start of their respective days
  // for accurate day-to-day comparison.
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const partyDay = new Date(partyDate.getFullYear(), partyDate.getMonth(), partyDate.getDate());

  const timeDiff = partyDay.getTime() - today.getTime();
  const dayDiff = Math.round(timeDiff / (1000 * 60 * 60 * 24));

  const formattedTime = _formatTimeForDate(partyDate);

  // Constructing the full date string (e.g., "Thursday, May 22nd")
  // using provided utility functions and our helper for suffixes.
  const dayName = getDayOfWeek(partyDate);         // From your utilities
  const monthName = getMonth(partyDate);           // From your utilities
  const dayOfMonthStr = getDayNumeric(partyDate);  // From your utilities (e.g., "22", "05")
  const dayOfMonthNum = parseInt(dayOfMonthStr, 10); // Convert to number for suffix and display

  const suffix = _getOrdinalSuffixForDate(dayOfMonthNum); // Our helper

  const formattedFullDate = `${dayName}, ${monthName} ${dayOfMonthNum}${suffix}`;

  if (dayDiff === 0) {
    return `Today at ${formattedTime}`;
  } else if (dayDiff === 1) {
    return `Tomorrow at ${formattedTime} / ${formattedFullDate}`;
  } else {
    return formattedFullDate;
  }
}





